import ComicCard from '@/components/base/ComicCard';
import { getLatestComics } from '@/mocks/comics';

export default function LatestSection() {
  const latestComics = getLatestComics();

  return (
    <section className="max-w-[1400px] mx-auto px-4 md:px-6 py-12 md:py-16">
      <div className="flex items-center justify-between mb-6 md:mb-8">
        <div>
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">
            最近更新
          </h2>
          <p className="text-sm text-foreground-500 mt-1">实时追踪最新韩国漫画更新</p>
        </div>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5" data-product-shop>
        {latestComics.map((comic) => (
          <ComicCard key={comic.id} comic={comic} />
        ))}
      </div>
    </section>
  );
}